import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, Renderer2 } from '@angular/core';

@Component({
    selector: 'ham-confirm-decline-modal',
    template: `
        <div class="ham-modal-confirm-decline">
            <div class="ham-modal-confirm-decline-inner">
                <span
                    class="close"
                    hamIconShapes
                    icon="assets/hamIcons/x.svg"
                    variant="transparent"
                    size="xs"
                    type="circle"
                    (click)="onCancel()"
                ></span>
                <div class="modal-confirm-decline-header" *ngIf="title">
                    <span>{{ title }}</span>
                    <span class="icon" (click)="onCancel()">
                        <i class="close-icon x-icon"></i>
                    </span>
                </div>

                <div class="modal-confirm-decline-body">
                    <ng-content></ng-content>
                </div>

                <div class="modal-confirm-decline-footer" [ngStyle]="{ 'justify-content': footerAlignment }">
                    <button *ngIf="!hideCancelButton" class="cancel" (click)="onCancel()">{{ noActionBtnText }}</button>
                    <ham-button (buttonClick)="onAction()" [variant]="btnVariant" [disabled]="actionBtnDisabled">{{
                        actionBtnText
                    }}</ham-button>
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./confirm-decline-modal.component.scss'],
})
export class HamConfirmDeclineModalComponent implements AfterViewInit, OnDestroy {
    @Input() title: string;
    @Input() noActionBtnText: string;
    @Input() actionBtnText: string;
    @Input() footerAlignment: 'left' | 'right' | 'center' = 'center';
    @Input() btnVariant: 'primary' | 'gray' | 'red' | 'teal' | 'green' | 'white' | 'red' = 'red';
    @Input() actionBtnDisabled = false;
    @Input() hideCancelButton = false;
    @Output() cancel = new EventEmitter<void>();
    @Output() action = new EventEmitter<void>();

    onCancel() {
        this.cancel.emit();
    }

    onAction() {
        this.action.emit();
    }


    constructor(
        private el: ElementRef,
        private renderer: Renderer2, // Inject Renderer2
    ) { }


    private element: HTMLElement;

    ngAfterViewInit(): void {
        this.element = this.el.nativeElement;

        // Move modal to the global placeholder
        this.moveModalToGlobalPlaceholder();
    }

    private moveModalToGlobalPlaceholder() {
        const placeholder = this.renderer.selectRootElement('#global-modal-placeholder', true);
        if (placeholder) {
            // Use Renderer2 to append the modal element to the global placeholder
            this.renderer.appendChild(placeholder, this.element);
        }
    }

    ngOnDestroy() {
        // Clean up the DOM using Renderer2
        if (this.element && this.element.parentElement) {
            this.renderer.removeChild(this.element.parentElement, this.element);
        }
    }
}
